import { Tab, Tabs } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
export default function DetailsTabs(props) {
  const { tabValue, setTabValue, ISIN } = props;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const states = useSelector((state) => state.states.value);
  const companies = states?.companies[states?.companies?.length - 1]
    ? states?.companies[states?.companies.length - 1]
    : [];

  let { queryISIN } = useParams();

  const Company = companies?.find((company) => company.ISIN === ISIN);

  return (
    <>
      <div
        style={{
          height: isDesktopOrLaptop ? "66px" : "50px",
          display: "flex",
          width: "100%",
          alignItems: "flex-end",
        }}
      >
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, val) => {
            setTabValue(val);
          }}
          variant={isDesktopOrLaptop ? "standard" : "scrollable"}
          TabIndicatorProps={{
            style: {
              background: "#0040ff",
              height: "8px",
              borderRadius: "21px",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
              padding: "0px",

              //   justifySelf: "center",
            },
          }}
          centered
          inkBarStyle={{ background: "#0040f" }}
          style={{}}
        >
          <Tab
            value={0}
            label={<span>{props.t("general_info")}</span>}
            style={{
              color: tabValue === 0 ? "#16063b" : "#808080",
              fontWeight: tabValue === 0 ? "bold" : "normal",
              textTransform: "capitalize",
              fontFamily: "Overpass",
              fontSize: isDesktopOrLaptop ? "16px" : "12px",
              display: "flex",
              marginRight: isDesktopOrLaptop ? "105px" : "20px",
              minWidth: isDesktopOrLaptop ? "40px" : "35px",
              padding: 0,
            }}
          />
          {Company?.News && states.tabValue !== 2 ? (
            <Tab
              value={1}
              label={<span>{props.t("news")}</span>}
              style={{
                color: tabValue === 1 ? "#16063b" : "#808080",
                fontWeight: tabValue === 1 ? "bold" : "normal",
                textTransform: "capitalize",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "16px" : "12px",
                minWidth: isDesktopOrLaptop ? "40px" : "35px",
                marginRight: isDesktopOrLaptop ? "105px" : "20px",
                padding: 0,
              }}
            />
          ) : null}
          {states.tabValue !== 2 ? (
            <Tab
              value={2}
              label={<span>{props.t("competitors")}</span>}
              style={{
                color: tabValue === 2 ? "#16063b" : "#808080",
                fontWeight: tabValue === 2 ? "bold" : "normal",
                textTransform: "capitalize",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "16px" : "12px",
                minWidth: isDesktopOrLaptop ? "40px" : "35px",
                marginRight: isDesktopOrLaptop ? "105px" : "20px",
                padding: 0,
              }}
            />
          ) : null}
          {Company?.Brands && states.tabValue !== 2 ? (
            <Tab
              value={3}
              label={<span>{props.t("brands")}</span>}
              style={{
                color: tabValue === 3 ? "#16063b" : "#808080",
                fontWeight: tabValue === 3 ? "bold" : "normal",
                textTransform: "capitalize",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "16px" : "12px",
                minWidth: isDesktopOrLaptop ? "40px" : "35px",
                marginRight: isDesktopOrLaptop ? "105px" : "20px",
                padding: 0,
              }}
            />
          ) : null}
          {Company?.Bonds && states.tabValue !== 2 ? (
            <Tab
              value={4}
              label={<span>{props.t("bonds")}</span>}
              style={{
                color: tabValue === 4 ? "#16063b" : "#808080",
                fontWeight: tabValue === 4 ? "bold" : "normal",
                textTransform: "capitalize",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "16px" : "12px",
                minWidth: isDesktopOrLaptop ? "40px" : "35px",
                padding: 0,
                marginRight: isDesktopOrLaptop ? "105px" : "20px",
              }}
            />
          ) : null}
          {states.tabValue === 2 ? (
            <Tab
              value={5}
              label={<span>{props.t("holdings")}</span>}
              style={{
                color: tabValue === 5 ? "#16063b" : "#808080",
                fontWeight: tabValue === 5 ? "bold" : "normal",
                textTransform: "capitalize",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "16px" : "12px",
                minWidth: isDesktopOrLaptop ? "40px" : "35px",
                padding: 0,
                marginRight: isDesktopOrLaptop ? "105px" : "20px",
              }}
            />
          ) : null}
          {states?.tabValue !== 2 ? (
            <Tab
              value={6}
              label={<span>{"Links"}</span>}
              style={{
                color: tabValue === 6 ? "#16063b" : "#808080",
                fontWeight: tabValue === 6 ? "bold" : "normal",
                textTransform: "capitalize",
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "16px" : "12px",
                minWidth: isDesktopOrLaptop ? "40px" : "35px",
                padding: 0,
              }}
            />
          ) : null}
          )
        </Tabs>
      </div>
    </>
  );
}
